<template>
<div class='compass_wrapper'>
<div id="compass">
  <div id="bezel"></div>
  <div id="NWSE" class="quad"></div>
  <div id="NESW" class="quad"></div>
  <div id="NS" class="quad"></div>
  <div id="WE" class="quad"></div>
  <span id="N" class="dir">N</span>
  <span id="E" class="dir">E</span>
  <span id="S" class="dir">S</span>
  <span id="W" class="dir">W</span>
  <div id="needle"></div>
  <div id="axis"></div>
</div>
</div>
</template>

<script>

  export default {
    name: 'Compass',
    props: ['title']
  }
</script>
  
<style lang="less">
.compass_wrapper {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: block;
  z-index: 20000000;
  opacity: 0;
  transition: 0.5s 0.25s;
  user-select: none;
  pointer-events: none;
}

.compassActive {
  opacity: 1;
}

#compass {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 30px;
  transform: scale(2);
}

#bezel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  border: 3px solid #eee;
  border-radius: 50%;
  background: white;
  box-shadow: -5px 2px 40px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 10px rgba(0, 0, 0, 0.3), 0 10px 20px 20px rgba(0, 0, 0, 0.2), -1px 0px 4px  rgba(0, 0, 0, 0.2) !important;
}

#axis {
  position: absolute;
  left: 46px;
  top: 45px;
  width: 5px;
  height: 5px;
  background: #fff;
  border: 3px solid #666;
  border-radius: 50%;
}

#needle {
  position: absolute;
  left: 48px;
  width: 2px;
  height: 80px;
  top: 8px;
  -webkit-animation: spin 2s ease infinite;
  -moz-animation: spin 2s ease infinite;
  animation: spin 2s ease infinite;
}

#needle:after {
  content: '';
  position: absolute;
  top: 0;
  left: -1px;
  width: 0;
  height: 0;
  border: 2px solid transparent;
  border-bottom: 40px solid #FF3600;
}

#needle:before {
  content: '';
  position: absolute;
  top: 40px;
  left: -1px;
  width: 0;
  height: 0;
  border: 2px solid transparent;
  border-top: 40px solid #666;
}

#N {
  position: absolute;
  top: 5px;
  left: 39px;
  color: #FF3600;
}

#E {
  position: absolute;
  right: 5px;
  top: 39px;
}

#S {
  position: absolute;
  bottom: 5px;
  left: 39px;
}

#W {
  position: absolute;
  left: 5px;
  top: 39px;
}

.dir {
  font-family: arial, sans-serif;
  color: #999;
  font-size: 10px;
  background: #fff;
  padding: 5px;
}

.quad {
  display: block;
  width: 1px;
  background: #ddd;
  height: 80px;
  position: absolute;
  top: 8px;
  left: 48px;
}

#NWSE {
  transform: rotate(45deg);
}

#NESW {
  transform: rotate(-45deg);
}

#WE {
  transform: rotate(90deg);
}

@-moz-keyframes spin {
  100% {
    -moz-transform: rotate(360deg);
  }
}

@-webkit-keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}


</style>





// WEBPACK FOOTER //
// src/components/library/compass.vue